module.exports = __webpack_public_path__ + "static/media/WashTile.18ed39df.jpg";